import React from 'react'
import AnnouncementCard from 'components/AnnouncementCard'
import { createUseStyles } from 'react-jss'
import { PropertyAnnouncement } from 'types/propertyAnnouncement'
import { useCommonStyles } from 'styles/globalStyles'
import StepButtons from '../../../../components/StepButtons'

type Props = {
  property: PropertyAnnouncement
  onClickSave: () => void
  onPressBack: () => void
}

const Confirmation = (props: Props) => {
  const classes = useStyles(props)
  const commonClasses = useCommonStyles(props)
  const { user } = props.property
  return (
    <div>
      <p className={`${commonClasses.subtitle} ${classes.description}`}>
        Aqui está a prévia do seu anúncio. Você pode editar e personalizar ainda mais o seu anúncio
        pelo aplicativo.
      </p>

      <div className={classes.cardContainer}>
        <AnnouncementCard
          details={props.property.info}
          propertyImages={props.property.images}
          values={props.property.values}
          tenantPays={props.property.tenant_pays}
          landlordImage={{ name: user.name, profile_image: user.profile_image }}
        />
      </div>
      <StepButtons onPressNext={props.onClickSave} onPressBack={props.onPressBack} />
    </div>
  )
}

const useStyles = createUseStyles({
  propertyAreaContainer: {
    margin: '16px 0 32px',
  },
  autocompleteContainer: {
    margin: '16px 0 32px',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  description: {
    textAlign: 'left',
  },
})

export default Confirmation
